import { useCallback, useContext, useMemo } from 'react';
import { useService } from '@core/inversify-react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';
import { useBus } from '@core/event-bus';

import { useBoxById } from './';
import { CreateBoxDto } from '../dtos';
import { CreateBoxMapper } from '../mappers';
import { CreateBoxContext } from '../contexts';
import { CreateBoxRepo, CreateBoxRepoType } from '../repos';

export const useCreateBox = () => {
  const { id, onSucceed } = useContext(CreateBoxContext);
  const order = useBoxById(id, { enabled: !!id });

  const createCourierRepo = useService<CreateBoxRepo>(CreateBoxRepoType);
  const eventBus = useBus();

  const initialValues = useMemo<CreateBoxDto | undefined>(() => {
    if (id) {
      return order.data ? CreateBoxMapper.toDomain(order.data) : undefined;
    }

    return { name: '', branchId: '' };
  }, [id, order.data]);

  const onSubmit = useCallback(
    async (values: CreateBoxDto, helpers: FormikHelpers<CreateBoxDto>) => {
      helpers.setStatus(null);
      const result = await createCourierRepo.execute(values, id || undefined);

      if (result.status === 200) {
        if (!id) {
          eventBus.publish({ type: '@boxes/create/succeed' });
        } else {
          eventBus.publish({ type: '@boxes/update/succeed' });
        }

        onSucceed?.();
      } else if (result.status === 422) {
        helpers.setErrors(result.response);
      } else {
        message.error(result.response);
      }
    },
    [createCourierRepo, eventBus, id, onSucceed],
  );

  return { onSubmit, initialValues };
};
